import { createSlice } from "@reduxjs/toolkit";
import {
  connectTikTokAccount,
  createTikTokPost,
  getTikTokAuthToken,
  getTikTokAuthUrl,
  getTikTokPost,
} from "./thunk";

const initialState = {
  tikTokData: [],
  tikTokAuthData: [],
  tikTokAuthTokenData: [],
  tikTokLoading: false,
  error: null,
};

const tikTokSlice = createSlice({
  name: "tikTok",
  initialState,
  reducers: {
    resetTikTokData: (state) => {
      state.tikTokLoading = false;
      state.tikTokData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------------------------------------------Connect X
      .addCase(connectTikTokAccount.pending, (state) => {
        state.tikTokLoading = true;
        state.error = null;
      })
      .addCase(connectTikTokAccount.fulfilled, (state, action) => {
        state.tikTokLoading = false;
        state.tikTokData = action.payload;
      })
      .addCase(connectTikTokAccount.rejected, (state, action) => {
        state.tikTokLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Create post
      .addCase(createTikTokPost.pending, (state) => {
        state.tikTokLoading = true;
        state.error = null;
      })
      .addCase(createTikTokPost.fulfilled, (state, action) => {
        state.tikTokLoading = false;
        state.tikTokData = action.payload;
      })
      .addCase(createTikTokPost.rejected, (state, action) => {
        state.tikTokLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get post
      .addCase(getTikTokPost.pending, (state) => {
        state.tikTokLoading = true;
        state.error = null;
      })
      .addCase(getTikTokPost.fulfilled, (state, action) => {
        state.tikTokLoading = false;
        state.tikTokData = action.payload;
      })
      .addCase(getTikTokPost.rejected, (state, action) => {
        state.tikTokLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get auth url
      .addCase(getTikTokAuthUrl.pending, (state) => {
        state.tikTokLoading = true;
        state.error = null;
      })
      .addCase(getTikTokAuthUrl.fulfilled, (state, action) => {
        state.tikTokLoading = false;
        state.tikTokAuthData = action.payload;
      })
      .addCase(getTikTokAuthUrl.rejected, (state, action) => {
        state.tikTokLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get auth token
      .addCase(getTikTokAuthToken.pending, (state) => {
        state.tikTokLoading = true;
        state.error = null;
      })
      .addCase(getTikTokAuthToken.fulfilled, (state, action) => {
        state.tikTokLoading = false;
        state.tikTokAuthTokenData = action.payload;
      })
      .addCase(getTikTokAuthToken.rejected, (state, action) => {
        state.tikTokLoading = false;
        state.error = action.payload;
      })
  },
});

export const { resetTikTokData } = tikTokSlice.actions;
export default tikTokSlice.reducer;
